/*
    *******************************************
    Created By: Josh C.
    Date: 12/29/2011

    This is a code file which is intended to streamline ALL reporting procedures.
    Everything from report printing to pdf previewing.

    .:The Problem:.
    Every report that is run must have the parameters associated with it evaluated.
    If there are any required parameters that aren't matched, the report needs to prompt the user
    to input the aforementioned/required values in order to preview.
    *******************************************
*/

// This function takes a JavaScript 'window' object and
// tells you whether it's been opened successefully or not.
// This method should work across all supported browsers (more or less).
function _isWindowBlocked(window) {
    var blocked = false;
    if (window == undefined || window.closed == undefined || typeof window.closed === undefined)
        blocked = true;
    return blocked;
}

function _resizeParamWindow() {
    var paramWindow = Ext.getCmp('paramWindow');
    var height = paramWindow.getHeight();
    var panel = Ext.getCmp('paramPanel');
    panel.setHeight(height - 60);                   // bottom menu + dummy panel kludge
    var width = paramWindow.getWidth() - 14;        // vertical scroll bar
    panel.setWidth(width);
    for (var i = 0; i < panel.items.length; i++) {
        panel.items.items[i].setWidth(width - 40);  // padding on both sides
    }
};

// validating the parameter value
function requiredValidator(value) {
    if (value.length === 0) return false;
    return true;
}

// validating the parameter value is in GUID format
function isGuid(value) {
    var regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
    var match = regex.exec(value);
    return match != null;
}


// define endsWith in Javascript if needed
if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

var Report =
{
    //I am using "_[fn]" to signify "private" methods. Or methods that should really not be used outside the scope.
    //I guess you could use them if you really wanted to...
    _getParameters: function (reportName, parameters) {
        var resultList = [];

        $.ajax({
            url: '/Crystal/GetMissingParameters',
            type: 'POST',
            async: false,
            dataType: 'json',
            data:
            {
                reportName: reportName,
                existingParameters: parameters
            },
            success: function (result) {
                resultList = result.names;
            }
        });

        return resultList;
    },
    //NOTE: parameters will conform to the following schema: { Key: key, Value: value };
    _promptForParameters: function (reportName, parameters, callback, title) {

        //HEAVY Function call.
        //TODO: (minor/non-issue - just annoying) try to implement some cache/hash
        //for the report parameters on the server side.
        var params = Report._getParameters(reportName, parameters);
        if (parameters !== undefined) {
            //ToDo: take the params array and remove anything that is already contained
            //within the parameters variable.
            var end = params.length - 1;
            //ToDo: Make this NOT O( n^2 ) o____o
            //Iterate through the parameter list associated with the passed in report.
            for (var i = 0; i < params.length; i++) {
                if (params[i] === undefined) continue;

                //Iterate through all of the known parameters that have values.
                for (var r = 0; r < parameters.length; r++) {
                    //If there is a collision
                    if (params[i].cDataIndex === parameters[r].Key) {
                        //Swap the parameter with the end of the list.
                        params[i].cDisplayName = params[end].cDisplayName;
                        params[i].cDataIndex = params[end].cDataIndex;
                        // Adding the missing items here when swapping the parameter with the end of list 
                        params[i].cDataType = params[end].cDataType;
                        params[i].comboValues = params[end].cDataType == 'combo' ? params[end].comboValues : '';
                        params[i].cMinimumValue = params[end].cMinimumValue;
                        params[i].cMaximumValue = params[end].cMaximumValue;
                        params[i].cInitialValue = params[end].cInitialValue;

                        //Set the end to null
                        params[end--] = undefined;
                        //reduce the list length.
                        params.length--;
                        i--;
                        //In essence, the above code removes an item from the list.
                        break;
                        //We're done here.
                    }
                }
            }
        } //End of if statement for parameters

        if (params.length === 0) {
            callback(undefined, parameters);
            return;
        }

        // Iterate through the parameters and create a panel
        // that represents what we need.
        var panel = new Ext.Panel({
            id: 'paramPanel',
            padding: 10,
            layout: 'auto',
            autoScroll: true,
            items: {
                xtype: 'displayfield',
                value: ___('PLEASE_ENTER_THE_PARAMETERS_REQUIRED_FOR_THIS_REPORT') + '<br/><br/>',
            }
        });

        var panelDummy = new Ext.Panel({
            height: 20,
            width: 'auto'
        });

        // Populate the panel fields.
        for (var i = 0; i < params.length; i++) {
            // First create a label.
            var displayName = params[i].cDisplayName;
            var label = new Ext.form.DisplayField({
                style: 'font-weight: bold',
                value: ___(displayName),
                padding: 10
            });

            // Next, create a field.
            // note: using a sort-of factory pattern.
            var field;
            var ParameterValue = null;

            // Derrive the type of field.
            switch (params[i].cDataType) {
                case "datefield":
                    field = new Ext.form.DateField({
                        name: params[i].cDataIndex,
                        id: params[i].cDataIndex,
                        padding: 10
                    });
                    break;
                // configure the combo control on the screen 
                case "combo":
                    field = new Ext.form.ComboBox({
                        name: params[i].cDataIndex,
                        id: params[i].cDataIndex,
                        allowBlank: false,
                        systemRequired: true,
                        store: params[i].comboValues,
                        listeners: {
                            // This is bit tricky  - To allow empty combo item selection 
                            select: function (self) {
                                if (self.getValue() == '') {
                                    self.emptyText = '';
                                    self.allowBlank = true;
                                }
                            }
                        },
                        displayField: 'value',
                        valueField: 'value',
                        typeAhead: true,
                        mode: 'remote',
                        triggerAction: 'all',
                        emptyText: 'Select One...',
                        selectOnFocus: true
                    });
                    break;
                default:
                    if (params[i].cMinimumValue === '' && params[i].cMaximumValue === '') { 
                        ParameterValue = params[i].cInitialValue;
                    }

                    field = new Ext.form.TextField({
                        name: params[i].cDataIndex,
                        id: params[i].cDataIndex,
                        padding: 10,
                        value: ParameterValue,
                        validator: requiredValidator
                    });
                    break;
            }

            // Add the items to the panel.
            panel.add(label);
            panel.add(field);
        }

        setTimeout(function () {
            //Create the parameter window which will store the values for optional parameters.
            var paramWindow = new Ext.Window({
                id: 'paramWindow',
                //Make it modal
                modal: true,
                width: 350,
                height: 350,
                minimizable: false,
                bbar: new Ext.Toolbar({
                    items: [
                        {
                            xtype: 'button',
                            iconCls: 'btn-cancel-sm',
                            text: ___('CANCEL'),
                            tooltip: ___('CANCEL'),
                            handler: function () {
                                paramWindow.close();
                            }
                        },
                        '->',
                        {
                            xtype: 'button',
                            iconCls: 'btn-print-sm',
                            text: ___('PROCESS'),
                            tooltip: ___('PROCESS'),
                            id: 'btnProcess',
                            handler: function () {
                                // Iterate through the items and gather the parameters.
                                var items = panel.items;
                                var formParameters = [];
                                var isValid = true;

                                // Start at 1 + label to skip the little message, and then incriment by two to skip the labels,
                                for (var i = 2; i < panel.items.length; i += 2) {
                                    var val = '';
                                    if (panel.items.items[i].getXType() == "datefield") {
                                        var date = new Date(panel.items.items[i].getValue());
                                        if (date instanceof Date) {
                                            // Check whether this is a start date.
                                            if (panel.items.items[i].name == 'StartDate') {
                                                date.setHours(0, 0, 0);
                                            } else {
                                                date.setHours(23, 59, 59);
                                            }
                                            val = date.toISOString();
                                        } else {
                                            val = panel.items.items[i].getRawValue();
                                        }
                                    }
                                    // Add the validation - to select the combo box values before proceed
                                    else if (panel.items.items[i].getXType() == "combo") {
                                        var comboValue = panel.items.items[i].getRawValue();
                                        // Check If the "static list" contains a blank value and 
                                        // allow user to selecting it, If the static list, does not contain a blank value, don't allow blanks to be valid.

                                        var emptyComboValue = false;

                                        if (comboValue == '') {
                                            for (var p = 0; p < panel.items.items[i].store.data.length; p++) {
                                                if (panel.items.items[i].store.data.items[p].data["field1"] == '')
                                                    emptyComboValue = true;
                                            }
                                        }

                                        if (emptyComboValue) {
                                            // validation part for the combo which has a blank value but no selection done 
                                            if (panel.items.items[i].emptyText != '' && panel.items.items[i].allowBlank == false)
                                                return;
                                            else
                                                val = panel.items.items[i].getRawValue();
                                        }
                                        else {
                                            if (comboValue == '' || comboValue == null || comboValue == undefined)
                                                return;
                                            else
                                                val = panel.items.items[i].getRawValue();
                                        }
                                    }
                                    else {
                                        val = panel.items.items[i].getRawValue();

                                        // Check if the parameter value is valid Minimum, Minimum and GUID
                                        for (var j = 0; j <= params.length - 1; j++) {
                                            if (params[j].cDataIndex === panel.items.items[i].id) {

                                                // Check input value is in GUID format
                                                if (params[j].cDataIndex.endsWith("UID")) {
                                                    if (val.length != 36 || !isGuid(val)) {
                                                        Ext.getCmp(panel.items.items[i].id).setActiveError();
                                                        Ext.getCmp(panel.items.items[i].id).markInvalid();
                                                        isValid = false;
                                                    }
                                                }

                                                // check Minimum Value is valid
                                                if (params[j].cMinimumValue != 0 && val.length < params[j].cMinimumValue) {
                                                    // Red squiggle the field.
                                                    Ext.getCmp(panel.items.items[i].id).setActiveError();
                                                    Ext.getCmp(panel.items.items[i].id).markInvalid();
                                                    isValid = false;
                                                }

                                                // check Maximum Value is valid
                                                if (params[j].cMaximumValue != 0 && val.length > params[j].cMaximumValue) {
                                                    // Red squiggle the field.
                                                    Ext.getCmp(panel.items.items[i].id).setActiveError();
                                                    Ext.getCmp(panel.items.items[i].id).markInvalid();
                                                    isValid = false;
                                                }
                                            }
                                        }
                                    }

                                    formParameters[formParameters.length] = {
                                        Key: panel.items.items[i].name,
                                        Value: val
                                    };
                                }

                                // Checking if all the input values are valid
                                // Submit the info
                                if (isValid) {
                                    if (callback !== undefined)
                                        callback(formParameters, parameters);
                                    paramWindow.close();
                                }
                            }
                        }
                    ]
                }),
                title: ___('REPORT_PARAMETERS_TITLE'),
                items: [
                    panel,
                    panelDummy
                ],
                // listener to hide the wait bar on closing the param window.
                listeners: {
                    close: function () {
                        HideWaitBar();
                    },
                    resize: function () {
                        _resizeParamWindow();
                    },
                    show: function (self) {
                        _resizeParamWindow();
                    }
                }
            }).show();
        }, 300);
    },
    //"Public" methods below...
    ReportExists: function (reportName) {
        var result = false;

        //Check if the report exists.
        var jqXHR = $.ajax({
            url: '/Crystal/DoesReportExist',
            data: {
                __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
                id: reportName
            },  
            dataType: 'json',
            type: 'POST',
            async: false,
            success: function (result) {
                if (!result.success) {
                    Ext.Msg.alert(___('ATTENTION_TITLE'), result.message, function () { });
                }
            }
        });

        var result = JSON.parse(jqXHR.responseText);
        return result.success;
    },
    PreviewReport: function (reportName, parameters, alternateLocation, skipParameterLookup, redirectParent, reportType, config, outputName) {

        ShowWaitBar();


        // Delay the processing, to give the interface a chance to render
        // the wait bar. Because the following code will pretty much lock everything up.
        setTimeout(function () {

            if (config === undefined || config === null)
                config = [];

            // check if reporttype is undefined if so setting it as "Print" 
            // Since we do send reportType as "Export" for Excel document preview and this is to support for if any other print previews
            if (reportType === undefined || reportType == null)
                reportType = "Print";

            if (skipParameterLookup === undefined)
                skipParameterLookup = false;

            if (redirectParent === undefined)
                redirectParent = false;

            // Setup the title.
            var title = ___("PREVIEW_REPORT");
            if (config.title !== undefined)
                title = config.title;

            //Redirect parent is an optional parameter which, if true, bypasses the
            //preview functionality and just redirects the parent page to whatever the "alternateLocation" is defined as.
            //Useful in cases like with Returning.
            if (redirectParent === undefined)
                redirectParent = false;

            reportName = decodeURI(reportName) // Decoding the reportname to retain the spcaces if the report name has spaces in their names

            var reportExists = Report.ReportExists(reportName);
            if (!reportExists) return;

            //Process ALL the things.
            function process(missingParameters, parameters) {
                //Make sure there are parameters before processing them.
                if (missingParameters !== undefined) {
                    //Concatenate missingParameters with supplied paramteters.

                    if (parameters == undefined) {
                        parameters = missingParameters;
                    }
                    else {

                        for (r = 0; r < missingParameters.length; r++)
                            //access the end of the parameter list (with the offset of "r") and then append
                            //the value to the parameter list. While doing this, increment the length to match the new value.
                            parameters[parameters.length] = missingParameters[r];

                        //Readjust the length.
                    }
                }


                //If no alternate location was specified, use the default.
                if (alternateLocation == undefined)
                    alternateLocation = '/Crystal/RenderReport';

                // Complex assumptions here... If it doesn't end with an ampersand,
                // I am going to assume they have no pre-specified querystring data
                // so we can append a questionmark. Otherwise, we can just tack on whatever
                // we have to produce a valid querystring.
                if (alternateLocation[alternateLocation.length - 1] != "&")
                    alternateLocation += "?";

                //Setup the alternateLocation querystring data.
                //sending reportType through url as a querystrings
                alternateLocation += "id=" + reportName + "&reportName=" + reportName + "&reportType=" + reportType;
                if (outputName !== undefined && outputName !== null)
                    alternateLocation += "&outputName=" + outputName;

                // MTM-382 
                if (parameters !== undefined) {
                    //Serialize all of the parameters.
                    for (var i = 0; i < parameters.length; i++) {
                        alternateLocation += "&parameters[" + i + "].Key=" + escape(parameters[i].Key);
                        alternateLocation += "&parameters[" + i + "].Value=" + escape(parameters[i].Value);
                    }
                }

                // Hide the wait bar, if it's been popped up.
                HideWaitBar();

                // Since Cookies and other options did not worked here, I had to post the data to have check at the server side
                // Formed a Ajax call to post the data first and added a check condition at server 
                $.ajax({
                    url: '/Crystal/InitialReportRender',
                    data: {
                        __RequestVerificationToken: getWindowAntiForgeryTokenValue()
                    },  
                    type: 'post',
                    dataType: 'json',
                    async: false,
                    success: function (result) {
                        if (result.success == true) {
                            // skipping the parameters if undefined still blows up down the line, with a server error 'missing parameters'
                            //Render the report.
                            var win = window.open(alternateLocation, '_blank');
                            if (_isWindowBlocked(win)) {
                                // add message about popup blocker.
                                if (app !== undefined && app["showError"] !== undefined) {
                                    app.showError(___('ATTENTION_TITLE'), ___('POPUP_BLOCKER_FOUND_REPORT'), function () { });
                                }
                            }

                            try {
                                if (redirectParent || (config || {}).closeParent === true)
                                    clientWindow.close();
                            } catch (ex) { }
                        }
                    }
                });
            }

            if (!skipParameterLookup)
                Report._promptForParameters(reportName, parameters, process, title);
            else
                process(undefined, parameters);
        }, 150);
    }

};
